module.exports = __webpack_public_path__ + "img/logo-registration.2822182f.svg";